// extracted by mini-css-extract-plugin
export var typingIndicator = "_qu-0";